import { pic } from '../../data/site';

export const NAV = [
  { k:'dash', label:'Dashboard', icon:'▦' },
  { k:'dest', label:'Destinations', icon:'◈' },
  { k:'hotels', label:'Hotels', icon:'▣' },
  { k:'tours', label:'Tours & Excursions', icon:'▲' },
  { k:'cruises', label:'Cruises', icon:'⛵' },
  { k:'events', label:'Events & Experiences', icon:'🎉' },
  { k:'countryGuides', label:'Country Guides', icon:'🌍' },
  { k:'bookings', label:'Bookings & Inquiries', icon:'▤' },
  { k:'blog', label:'Blog Posts', icon:'✎' },
  { k:'testi', label:'Testimonials', icon:'★' },
  { k:'banners', label:'Homepage Banners', icon:'▭' },
  { k:'pricing', label:'Pricing & Availability', icon:'$' },
  { k:'media', label:'Media Library', icon:'◱' },
  { k:'settings', label:'Settings', icon:'⚙' },
];

export const TITLES = {
  dash:   ['Dashboard', 'Overview of your agency at a glance'],
  dest:   ['Destinations', 'Add, edit and remove destinations'],
  hotels: ['Hotels', 'Choose which supplier hotels appear on the site, and what you charge for them'],
  form:   ['Add destination', 'Full details, gallery and pricing'],
  tours:  ['Tours & Excursions', 'Manage bookable experiences'],
  cruises:['Cruises', 'Sailing areas, pricing and the copy on each cruise page'],
  events:['Events & Experiences', 'The recurring events the agency plans trips around'],
  countryGuides:['Country Guides', 'The tab content on each /regions country page'],
  bookings:['Bookings & Inquiries', 'Track and update client bookings'],
  blog:   ['Blog Posts', 'Publish travel guides and tips'],
  testi:  ['Testimonials', 'Curate reviews shown on the site'],
  banners:['Homepage Banners', 'Control the hero imagery'],
  pricing:['Pricing & Availability', 'Manage package pricing per tier'],
  media:  ['Media Library', 'Upload and organise photos'],
  settings:['Settings & Profile', 'Your account, agency and team'],
};

export const SETTINGS_SUBTABS = [
  ['profile', 'Profile'],
  ['agency', 'Agency'],
  ['team', 'Team'],
  ['notifications', 'Notifications'],
  ['integrations', 'Integrations'],
  ['billing', 'Billing'],
];

export const AGENCY_FIELDS = [
  { label:'Agency name', value:'HolaCaribe Travel' },
  { label:'WhatsApp number', value:'+1 809 555 0142' },
  { label:'Phone', value:'+1 809 555 0142' },
  { label:'Instagram handle', value:'@holacaribe.travel' },
  { label:'Support email', value:'hola@holacaribe.travel' },
  { label:'Office address', value:'Av. Winston Churchill, Santo Domingo' },
  { label:'Timezone', value:'(GMT-4) Santo Domingo' },
  { label:'Default currency', value:'USD ($)' },
];

export const TEAM = [
  { name:'Maria Alvarez', initials:'MA', email:'maria@holacaribe.travel', role:'Admin', status:'Active' },
  { name:'Diego Santos', initials:'DS', email:'diego@holacaribe.travel', role:'Editor', status:'Active' },
  { name:'Lucia Ferrer', initials:'LF', email:'lucia@holacaribe.travel', role:'Editor', status:'Active' },
  { name:'Tomas Reyes', initials:'TR', email:'tomas@holacaribe.travel', role:'Viewer', status:'Invited' },
  { name:'Ana Beltran', initials:'AB', email:'ana@holacaribe.travel', role:'Viewer', status:'Active' },
];

// Destination.Availability enum name -> the label the UI shows.
export const AVAILABILITY_LABEL = { Good:'Good', Limited:'Limited', SoldOut:'Sold out' };
export const AVAILABILITY_ORDER = ['Good', 'Limited', 'SoldOut'];

export const pillStyle = (kind) => {
  const map = {
    New:       { background:'rgba(14,138,156,0.14)', color:'#0c6d7c' },
    Pending:   { background:'rgba(169,118,26,0.16)', color:'#a9761a' },
    Confirmed: { background:'rgba(26,122,72,0.14)', color:'#1a7a48' },
    Live:      { background:'rgba(26,122,72,0.14)', color:'#1a7a48' },
    Active:    { background:'rgba(26,122,72,0.14)', color:'#1a7a48' },
    Scheduled: { background:'rgba(169,118,26,0.16)', color:'#a9761a' },
    Invited:   { background:'rgba(169,118,26,0.16)', color:'#a9761a' },
    Draft:     { background:'rgba(90,114,111,0.14)', color:'#5a726f' },
    Good:      { background:'rgba(26,122,72,0.14)', color:'#1a7a48' },
    Limited:   { background:'rgba(169,118,26,0.16)', color:'#a9761a' },
    'Sold out':{ background:'rgba(192,73,47,0.13)', color:'#c0492f' },
  };
  const c = map[kind] || map.Draft;
  return { display:'inline-block', padding:'5px 12px', borderRadius:100, fontSize:11.5, fontWeight:800, ...c };
};

export const DEST_GALLERY = [
  pic('puntacana,beach,palm', 11, 300, 220),
  pic('resort,pool,tropical', 71, 300, 220),
  pic('beach,golden,hour', 72, 300, 220),
];

export const DEST_TAGS = ['Beach & Resort', 'Honeymoon', 'Family', 'All-inclusive', 'Diving'];
